import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { PublicClientService } from "@nexu-library/utilities";

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate {
  constructor(private _publicClientService: PublicClientService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    let api_key = localStorage.getItem("api_key");

    if (api_key) {
      return true;
    }

    // Si no hay una api_key en el almacenamiento local, intenta obtenerla de forma asíncrona
    return this._publicClientService.login().pipe(
      map((response) => {
        localStorage.setItem("api_key", response.access_token);
        return true;
      })
    );
  }
}
